module.exports = function getComposedEventPath(event) {
    if (event.path) return event.path;
    if (event.composedPath) return event.composedPath();

    const path = [];
    let element = element.target;

    do {
        path.push(element);

        if (element.tagName === 'HTML') {
            path.push(document);
            path.push(window);
            element = false;
        }

        element = element.parentElement;
    } while (element);

    return path;
};
